import React, {Component} from 'react'
import _ from 'lodash'
import SummaryRow from '../forms/newcaso/SummaryRow'
import moment from 'moment'

class CasoSummary extends Component{
    constructor(props){
        super(props);
        this.state = {
            options: []
        }
    }
    initComponent(nextProps){
        if(nextProps.summary){
            this.setState({options: nextProps.summary});
            return
        }
        let summaryObj = _.keyBy(nextProps.caso.options, 'field');
        summaryObj = _.mapValues(summaryObj, function(o) { return o.value; });
        if(nextProps.caso.status === 3){
            summaryObj.aprobacion = nextProps.caso.aprobacion;
            summaryObj.entregafinal = nextProps.caso.entregafinal;
        }else{
            summaryObj.entrega = nextProps.caso.entrega;
            summaryObj.envio = nextProps.caso.envio;
        }
        summaryObj.description = nextProps.caso.description;
        summaryObj.phone = nextProps.caso.phone;
        this.setState({options: summaryObj})
    }
    componentDidMount() {
        if(this.props.summary){
            this.setState({options: this.props.summary})
            return
        }
        this.initComponent(this.props)
    }
    componentWillReceiveProps(nextProps){
        this.initComponent(nextProps)
    }
    getAddress(type){
        let address;
        if(this.props.summary){
            const addresses = _.keyBy(this.props.addresses, 'id');
            let id;
            if(type === "completeBillingAddress"){
                if(!this.props.summary.billing_address) return
                id = Number(this.props.summary.billing_address);
            }else{
                if(!this.props.summary.address) return
                id = Number(this.props.summary.address);
            }
            address = addresses[id];
        } else {
            if(_.isEmpty(this.props.caso) || !this.props.caso[type]) return
            address = this.props.caso[type];
        }
        return(
            <div>
                {address.name}<br />
                {address.address}<br />
                {address.postal} {address.city}, {address.region}
            </div>
        )
    }
    printSummary(){
        const mywindow = window.open('', 'PRINT', 'height=700,width=900');

        mywindow.document.write('<html><head><title>' + document.title  + '</title><style>.fa{display:none}</style>');
        mywindow.document.write('</head><body style="background: #FFF"><div class="container-fluid">');
        mywindow.document.write('<div class="col-md-12" style="margin-top: 20px"><h2><small>Paciente: </small>'+this.props.caso.title+'</h2><hr /></div>');
        mywindow.document.write(document.getElementById("summary").innerHTML);
        mywindow.document.write('</div></body></html>');

        const head = mywindow.document.head;
        const link = mywindow.document.createElement("link");
        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = "/css/app.css";

        const css = 'button.btn { display: none; }',
            style = mywindow.document.createElement('style');

        style.type = 'text/css';
        if (style.styleSheet){
            style.styleSheet.cssText = css;
        } else {
            style.appendChild(mywindow.document.createTextNode(css));
        }


        head.appendChild(link);
        head.appendChild(style);

        const img = document.createElement("img");
        img.src = "/images/odontograma.svg";
        img.style = "margin-top: 50px; margin-left: 80px; margin-right: auto; width: 80%;";

        mywindow.document.body.appendChild(img);

        mywindow.document.close(); // necessary for IE >= 10
        mywindow.focus(); // necessary for IE >= 10*/
        setTimeout(function() {
            mywindow.print();
        }, 1000);
        // mywindow.close();
    }
    renderSummary(){
        const exclusionList = [
            "nombre",
            "apellidos",
            "fotos",
            "dicoms",
            "radios",
            "centro",
            "billing_address_checker",
            "expansionar_arcada_superior",
            "extruir_arcada_superior",
            "comprimir_arcada_superior",
            "rotar_arcada_superior",
            "cerrar_de_espacios_arcada_superior",
            "dar_torque_arcada_superior",
            "protuir_arcada_superior",
            "dar_angulacion_arcada_superior",
            "retruir_arcada_superior",
            "mesializar_arcada_superior",
            "intruir_arcada_superior",
            "distalar_arcada_superior",
            "expansionar_arcada_inferior",
            "extruir_arcada_inferior",
            "comprimir_arcada_inferior",
            "rotar_arcada_inferior",
            "cerrar_de_espacios_arcada_inferior",
            "dar_torque_arcada_inferior",
            "protuir_arcada_inferior",
            "dar_angulacion_arcada_inferior",
            "retruir_arcada_inferior",
            "mesializar_arcada_inferior",
            "intruir_arcada_inferior",
            "distalar_arcada_inferior",
            "dejar_diastema_en_correccion_espacios_bolton",
            "repartir_espacios_en_4_incisivos_correccion_espacios_bolton",
            "stripping_en_arcada_opuesta_correccion_espacios_bolton",
            "elasticos_centrar_linea_media",
            "diastema_11_21_centrar_linea_media",
            "stripping_sector_lateral_centrar_linea_media",
            "stripping_sectores_laterales_correcion_anteroposterior",
            "implantes_piezas_protesicas",
            "coronas_piezas_protesicas",
            "puentes_piezas_protesicas",
            "colocar_piezas_en_esp_edentulos_piezas_protesicas",
            "rotacion_ataches",
            "retencion_ataches",
            "extrusion_ataches",
            "mov_mesiodistales_ataches",
            "dar_angulacion_tip_arcada_superior",
            "elasticos_correcion_anteroposterior",
        ];
        const propNames = {
            nofotos: {
                prop: "Fotografías",
                col: 12,
                value: "No ha adjuntado fotografías del paciente"
            },
            noradios: {
                prop: "Radiografías",
                col: 12,
                value: "No ha adjuntado radiografías del paciente"
            },
            nodicoms: {
                prop: "DICOMS",
                col: 12,
                value: "No ha adjuntado archivos DICOM"
            },
            phone: {
                prop: "Teléfono",
                col: 4,
                order: 3
            },
            address: {
                prop: "Dirección",
                value: this.getAddress("completeAddress"),
                col: 6,
                order: 4
            },
            billing_address: {
                prop: "Dirección de facturación",
                value: this.getAddress("completeBillingAddress"),
                col: 6,
                order: 5
            },
            envio:{
                 prop: "Fecha de envío de modelos",
                 value: moment(this.state.options["envio"]).format("D MMMM YYYY"),
                 col: 4,
                 order: 1
            },
            entrega:{
                 prop: "Fecha de entrega de estudio",
                 value: moment(this.state.options["entrega"]).format("D MMMM YYYY"),
                 col: "4 bold",
                 order: 2
             },
            aprobacion:{
                prop: "Fecha de aprobación",
                value: moment(this.state.options["aprobacion"]).format("D MMMM YYYY"),
                col: 4,
                order: 1
            },
            entregafinal:{
                prop: "Fecha prevista de entrega alienadores",
                value: moment(this.state.options["entregafinal"]).format("D MMMM YYYY"),
                col: "4 bold",
                order: 2
            },
            description:{
                prop: "Observaciones",
                col: 12
            },
            arcada_superior:{
                prop: "Arcada superior",
                value: "title"
            },
            expansionar_arcada_superior_text: {
                prop: "Expansionar"
            },
            extruir_arcada_superior_text: {
                prop: "Extruir"
            },
            comprimir_arcada_superior_text: {
                prop: "Comprimir"
            },
            rotar_arcada_superior_text: {
                prop: "Rotar"
            },
            cerrar_de_espacios_arcada_superior_text: {
                prop: "Cerrar de espacios"
            },
            dar_torque_arcada_superior_text: {
                prop: "Dar torque"
            },
            protuir_arcada_superior_text: {
                prop: "Protuir"
            },
            dar_angulacion_arcada_superior_text: {
                prop: "Dar angulación"
            },
            retruir_arcada_superior_text: {
                prop: "Retruir"
            },
            mesializar_arcada_superior_text: {
                prop: "Mesializar"
            },
            intruir_arcada_superior_text: {
                prop: "Intruir"
            },
            distalar_arcada_superior_text: {
                prop: "Distalar"
            },
            arcada_inferior:{
                prop: "Arcada inferior",
                value: "title"
            },
            expansionar_arcada_inferior_text: {
                prop: "Expansionar"
            },
            extruir_arcada_inferior_text: {
                prop: "Extruir"
            },
            comprimir_arcada_inferior_text: {
                prop: "Comprimir"
            },
            rotar_arcada_inferior_text: {
                prop: "Rotar"
            },
            cerrar_de_espacios_arcada_inferior_text: {
                prop: "Cerrar de espacios"
            },
            dar_torque_arcada_inferior_text: {
                prop: "Dar torque"
            },
            protuir_arcada_inferior_text: {
                prop: "Protuir"
            },
            dar_angulacion_arcada_inferior_text: {
                prop: "Dar angulación"
            },
            retruir_arcada_inferior_text: {
                prop: "Retruir"
            },
            mesializar_arcada_inferior_text: {
                prop: "Mesializar"
            },
            intruir_arcada_inferior_text: {
                prop: "Intruir"
            },
            distalar_arcada_inferior_text: {
                prop: "Distalar"
            },
            correccion_espacios_bolton:{
                prop:"Corrección espacios Bolton",
                value: "title"
            },
            dejar_diastema_en_correccion_espacios_bolton_text:{
                prop:"Dejar diastema en"
            },
            repartir_espacios_en_4_incisivos_correccion_espacios_bolton_text:{
                prop:"Repartir espacios en 4 incisivos"
            },
            stripping: {
                prop:"Stripping",
                value:"title"
            },
            rampas_de_mordida: {
                prop: "Rampas de mordida",
                value: "title"
            },
            rampas_de_mordida_text: {
                prop: "Indicaciones"
            },
            stripping_en_arcada_opuesta_correccion_espacios_bolton_text:{
                prop:"Stripping en arcada opuesta"
            },
            centrar_linea_media:{
                prop:"Centrar linea media",
                value: "title"
            },
            centrar_linea_media_desviacion_superior:{
                prop: "Desviación superior"
            },
            centrar_linea_media_desviacion_inferior: {
                prop: "Desviación inferior"
            },
            elasticos_centrar_linea_media_text:{
                prop:"Elásticos"
            },
            diastema_11_21_centrar_linea_media_text:{
                prop:"Diastema 11-21"
            },
            stripping_sector_lateral_centrar_linea_media_text:{
                prop:"Stripping sector lateral"
            },
            correcion_anteroposterior:{
                prop:"Correción anteroposterior",
                value: "title"
            },
            elasticos_correcion_anteroposterior_text:{
                prop:"Elásticos"
            },
            stripping_sectores_laterales_correcion_anteroposterior_text:{
                prop:"Stripping sectores laterales"
            },
            piezas_protesicas:{
                prop:"Piezas protésicas",
                value: {
                    title: true,
                    subtitle: this.state.options["piezas_protesicas"]
                }
            },
            implantes_piezas_protesicas_text:{
                prop:"Implantes"
            },
            coronas_piezas_protesicas_text:{
                prop:"Coronas"
            },
            puentes_piezas_protesicas_text:{
                prop:"Puentes"
            },
            colocar_piezas_en_esp_edentulos_piezas_protesicas_text:{
                prop:"Colocar piezas en esp. edéntulos"
            },
            microtornillos:{
                prop:"Microtornillos",
                value: "title",
            },
            microtornillos_text:{
                prop:"indicaciones",
            },
            stripping_text:{
                prop:"Indicaciones"
            },
            aux:{
                prop: "Elementos auxiliares",
                value: {
                    super: true,
                    hide: this.state.options["aux"]
                },
                order: 10001
            },
            ataches:{
                prop:"Ataches",
                value: "title",
                order: 10002
            },
            ataches_text:{
                prop:"Ataches"
            },
            rotacion_ataches_text:{
                prop:"Rotación",
                order: 10003
            },
            extrusion_ataches_text:{
                prop:"Extrusión",
                order: 10004
            },
            retencion_ataches_text:{
                prop:"Retención",
                order: 10005
            },
            mov_mesiodistales_ataches_text:{
                prop:"Mov. mesiodistales",
                order: 10006
            },
            pestana_para_elasticos:{
                prop:"Pestaña para elásticos",
                value: "title",
                order: 10007
            },
            pestana_para_elasticos_text:{
                prop:"Pestaña para elásticos",
                order: 10008
            },
            elasticos:{
                prop:"Elásticos",
                value:"title",
                order: 10009
            },
            elasticos_clase_ii_dch:{
                prop:"Elásticos Clase II dch.",
                order: 10010
            },
            elasticos_clase_ii_izq:{
                prop:"Elásticos Clase II izq.",
                order: 10011
            },
            elasticos_clase_iii_dch:{
                prop:"Elásticos Clase III dch.",
                order: 10012
            },
            elasticos_clase_iii_izq:{
                prop:"Elásticos Clase III izq.",
                order: 10013
            },
            elasticos_anterior_si:{
                prop:"Elásticos anterior",
                order: 10014
            },
            elasticos_posterior_dch:{
                prop:"Elásticos posterior dch.",
                order: 10015
            },
            elasticos_posterior_izq:{
                prop:"Elásticos posterior izq.",
                order: 10016
            },
            recortado_para_botones:{
                prop:"Recortado para botones",
                value: "title",
                order: 10017
            },
            recortado_para_botones_text:{
                prop:"Recortado para botones",
                order: 10018
            },
            dar_angulacion_tip_arcada_inferior_text: {
                prop:"Dar angulación"
            },
            dar_angulacion_tip_arcada_superior_text: {
                prop:"Dar angulación"
            },
            centrar_linea_media_desviacion_superior_text: {
                prop:"Indicaciones desviación superior"
            },
            centrar_linea_media_desviacion_inferior_text: {
                prop:"Indicaciones desviación inferior"
            },
            sobrecorreccion:{
                prop:"Sobrecorrección",
                value: "title"
            },
            sobrecorreccion_text:{
                prop:"Indicaciones"
            }
        };
        const summaryValues = _.pickBy(this.state.options, _.identity);
        let summaryArray = _.map(summaryValues, function(value, prop) {
            if(!_.includes(exclusionList, prop)) {
                return {
                    order: propNames[prop] && propNames[prop].order ? propNames[prop].order : 10000,
                    prop: prop,
                    label: propNames[prop] && propNames[prop].prop ? propNames[prop].prop : prop,
                    value: propNames[prop] && propNames[prop].value ? propNames[prop].value : value,
                    col: propNames[prop] && propNames[prop].col ? propNames[prop].col : "6"
                };
            }
        });

        summaryArray = _.compact(summaryArray);
        summaryArray = _.sortBy( summaryArray, 'order');

        return summaryArray.map((row ,i) => {
            return (
                <SummaryRow col={row.col} key={row.prop + i} label={row.label} value={row.value}  />
            );
        })

    }

    render(){
        return(
            <div className="row" id="summary" style={{marginTop:"40px"}}>
                <div className="col-md-11">
                    <div className="row">
                        {this.renderSummary()}
                    </div>
                </div>
                <div className="col-md-1">
                    <button onClick={this.printSummary.bind(this)} className="btn btn-outline-secondary pull-right">
                        <i className="fa fa-print fa-1x" />
                    </button>
                </div>
            </div>
        )
    }
}
export default CasoSummary


// WEBPACK FOOTER //
// ./resources/assets/js/components/casos/CasoSummary.jsx